import AppModel from '@/models/AppModel'
import store from '@/store/model-store'

const isDebug = process.env.NODE_ENV !== 'production'

export default {
  apiSetStore: (bvModal, params, callback) => {
    const loginStatus = JSON.parse(localStorage.getItem('loginStatus'))
    if (loginStatus['prodInst'] === '1') {
      return true
    }

    return AppModel.post('meeting_info_update', bvModal, params, (res) => {
      if (isDebug) {
        console.log(res.data)
      }

      AppModel.validateStatus(res.data)

      let modelStore = store.getters.model
      if (!modelStore) {
        modelStore = {}
      }
      modelStore['meetingInfoUpdate'] = res.data
      store.commit('setModel', modelStore)

      return Promise.resolve(res.data)
    }, null, callback)
  },
  getStore: (key) => {
    return AppModel.getStore('meetingInfoUpdate', key)
  },
  removeStore: () => {
    delete store.getters.model.sign
  }
}
